var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#474239",
    d: "M1.444 8.61Q9.9 4.376 12.72 3.028C18.09.46 19.207.015 19.935 0c.16-.003.517.042.75.259.195.182.249.428.274.601a4.5 4.5 0 0 1 .033.875C20.7 5.25 19.44 13.776 18.8 17.712c-.271 1.665-.805 2.223-1.322 2.278-1.123.119-1.975-.853-3.063-1.672-1.702-1.282-2.663-2.08-4.315-3.331-1.91-1.446-.672-2.24.416-3.54.285-.34 5.233-5.511 5.328-5.98.012-.059.024-.278-.09-.393-.113-.116-.28-.076-.4-.045q-.256.067-8.156 6.196-1.158.914-2.097.89c-.69-.017-2.019-.449-3.006-.818-1.211-.452-2.174-.691-2.09-1.46q.065-.6 1.439-1.227"
  })));
};
export default SvgTelegram;